import React, { type ComponentType } from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import { teamName, packageName } from '../../common/constants.tsx';
import type { FormEmptyStateProps } from './types.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const FormEmptyState = lazy<ComponentType<FormEmptyStateProps>>(() =>
	import(
		/* webpackChunkName: "async-proforma-request-type-config-form-empty-state" */ './index'
	).then((exportedModule) => exportedModule.FormEmptyState),
);

export const AsyncFormEmptyState: ComponentType<FormEmptyStateProps> = (props) => (
	<JSErrorBoundary
		id="ProformaRTCFormEmptyStateWrapper"
		packageName={packageName}
		teamName={teamName}
	>
		<Placeholder fallback={<></>} name="form-empty-state">
			<FormEmptyState {...props} />
		</Placeholder>
	</JSErrorBoundary>
);
